__turbopack_context__.v({
  "description": "instructor-description-module-scss-module__85l7eG__description",
});
